import projection from '../generated/pwj5m3f1.json'; import { AcceptanceManifest } from '../types';
export const pwj5m3f1AcceptanceManifest = projection as AcceptanceManifest;
